import { CUSTOM_URL_TAGS, RECOMMENDED_URL_TAGS } from '../../../../fields'

import { UrlTags } from './types'

export const formatAdUrlTagsToBE = (
  url_tags_option: string,
  url_tags: UrlTags,
  partnershipUtmMedium: string,
  appName: string
): string | null => {
  switch (url_tags_option) {
    case RECOMMENDED_URL_TAGS:
      return `utm_source=Facebook&utm_medium=${partnershipUtmMedium ? partnershipUtmMedium : appName}&utm_campaign={{campaign.id}}&utm_content={{ad.name}}`
    case CUSTOM_URL_TAGS:
      return Object.entries(url_tags)
        .map(([key, value]) => (value ? `${key}=${value}` : ''))
        .filter(item => item.length)
        .map(item => item.trim().split(' ').join(''))
        .join('&')
    default:
      return null
  }
}
